import { auth } from '../firebase/firebase-client';
import { User } from 'firebase/auth';

export const authenticatedFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit,
) => {
  // Wait for auth to be ready before getting token
  // Prevents issues when auth state is still initializing
  let user: User | null = auth.currentUser;

  // Wait for auth state to be initialized if user not immediately available
  if (!user) {
    try {
      user = await new Promise<User | null>((resolve, reject) => {
        let unsubscribe: (() => void) | null = null;

        const timeout = setTimeout(() => {
          if (unsubscribe) unsubscribe();
          reject(
            new Error(
              'Authentication timeout: Auth state not initialized within 5 seconds. Ensure Firebase is properly initialized.',
            ),
          );
        }, 5000);

        unsubscribe = auth.onAuthStateChanged((authUser) => {
          clearTimeout(timeout);
          if (unsubscribe) unsubscribe();
          resolve(authUser);
        });
      });
    } catch (error) {
      throw error instanceof Error
        ? error
        : new Error('Failed to authenticate: Auth not available');
    }
  }

  if (!user) {
    throw new Error('Failed to authenticate: No user found');
  }

  const idToken = await user.getIdToken();

  if (!idToken) {
    throw new Error('Failed to authenticate: Could not get token');
  }

  return fetch(input, {
    ...init,
    credentials: 'include',
    headers: {
      ...init?.headers,
      'Authorization': `Bearer ${idToken}`,
      'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
};
